"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.date.to-string");exports.__esModule = true;exports.default = void 0;var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _EventEmitter2 = _interopRequireDefault(require("../../EventEmitter"));

var _TimeDate = _interopRequireDefault(require("../TimeDate"));
var _utils = _interopRequireDefault(require("./utils"));
var _utils2 = _interopRequireDefault(require("../utils"));var




TimeRange = /*#__PURE__*/function (_EventEmitter) {(0, _inheritsLoose2.default)(TimeRange, _EventEmitter);






  function TimeRange(arg, opts) {var _this;
    _this = _EventEmitter.call(this) || this;(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "start", void 0);(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "end", void 0);(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "partName", void 0);(0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_initOpts", undefined);
    _this._initOpts = opts;
    _this.start = new _TimeDate.default(arg.start);
    _this.end = new _TimeDate.default(arg.end);
    _this.partName = arg.partName;return _this;
  }TimeRange.

  fromMiddle = function fromMiddle(arg, opts) {
    return new TimeRange(_utils.default.getRangeFromMiddle(arg, opts), opts);
  };var _proto = TimeRange.prototype;_proto.

  getMiddleTs = function getMiddleTs() {
    var start = this.start.ts;
    var end = this.end.ts;
    return start + Math.round((end - start) / 2);
  };_proto.


  move = function move(num) {

    // TODO:
    // if ( isNull( this.partName ) ) {

    // }

    var d = new Date(this.getMiddleTs());
    _utils2.default.move(d, this.partName, num);var _utils$getRangeFromMi =
    _utils.default.getRangeFromMiddle({
      ts: d.getTime(),
      partName: this.partName },
    this._initOpts),start = _utils$getRangeFromMi.start,end = _utils$getRangeFromMi.end;
    this.start.setDate(start);
    this.end.setDate(end);
    this.emit('change', {});
  };_proto.

  setPartName = function setPartName(partName) {
    var r = _utils.default.getRangeFromMiddle(
    { ts: this.getMiddleTs(), partName: partName },
    this._initOpts);

    this.start.setDate(r.start);
    this.end.setDate(r.end);
    this.partName = partName;
    this.emit('change', {});
  };return TimeRange;}(_EventEmitter2.default);var _default =




TimeRange;exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/Range/index.js
// module id = 622
// module chunks = 0